import { render, staticRenderFns } from "./FilmDetails.vue?vue&type=template&id=00c6825a&scoped=true&"
import script from "./FilmDetails.vue?vue&type=script&lang=js&"
export * from "./FilmDetails.vue?vue&type=script&lang=js&"
import style0 from "./FilmDetails.vue?vue&type=style&index=0&id=00c6825a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6825a",
  null
  
)

export default component.exports